export enum OperacionAbmEnum {
  Crear = "Crear",
  Editar = "Editar",
  Borrar = "Borrar",
  Clave = "Clave",
  Ver = "Ver",
}
